'use strict';

document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('.menu');
  const menuBtnOpen = document.querySelector('.header__burger');
  const menuBtnClose = document.querySelector('.menu__close');

  menuBtnOpen.addEventListener('click', () => {
    menu.classList.add('menu__active');
    document.body.classList.add('no-scroll');
  });

  menuBtnClose.addEventListener('click', () => {
    menu.classList.remove('menu__active');
  });

  menu.addEventListener('click', (e) => {
    if (e.offsetX < 0) {
      menu.classList.remove('menu__active');
    }
  });

  window.addEventListener('keydown', (e) => {
    if (e.code === 'Escape' && menu.closest('.menu__active')) {
      menu.classList.remove('menu__active');
    }
  });

  menu.addEventListener('transitionend', (e) => {
    if (!menu.closest('.menu__active') && e.propertyName === 'transform') {
      document.body.classList.remove('no-scroll');
    }
  });

  const menuDropdown = document.querySelectorAll('.menu__btn');

  if (menuDropdown) {
    menuDropdown.forEach((item) => {
      item.addEventListener('click', (e) => {
        if (document.body.clientWidth < 992) {
          e.preventDefault();
          e.target.nextElementSibling.classList.add('menu__dropdown--open');
        }
      });
    });
  }

  const menuPrev = document.querySelectorAll('.menu__prev');

  if (menuPrev) {
    menuPrev.forEach((item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        e.target.parentElement.classList.remove('menu__dropdown--open');
      });

      let parentItem = item.closest('.submenu');
      if (!parentItem) {
        return;
      }

      parentItem = parentItem.closest('.menu__item--dropdown');
      if (parentItem) {
        let elLink = parentItem.querySelector('.menu__link');
        let text = elLink.innerText;
        item.innerText = text[0] + text.slice(1)
        .toLowerCase();
      }
    });
  }

  // footer menu
  const footerMenuTitle = document.querySelectorAll('.menu-footer__title');
  footerMenuTitle.forEach((item) => {
    item.addEventListener('click', (e) => {
      if (document.body.clientWidth < 768) {
        e.target.nextElementSibling.classList.toggle('opened');
      }
    });
  });
});